<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <circle cx="9.5" cy="8" r="1" fill="inherit" stroke="none" />
      <circle cx="14.5" cy="8" r="1" fill="inherit" stroke="none" />
      <circle cx="9.5" cy="12" r="1" fill="inherit" stroke="none" />
      <circle cx="14.5" cy="12" r="1" fill="inherit" stroke="none" />
      <circle cx="9.5" cy="16" r="1" fill="inherit" stroke="none" />
      <circle cx="14.5" cy="16" r="1" fill="inherit" stroke="none" />
    </svg>
  </span>
</template>
